<div class="w-full min-h-screen" [attr.lang]="i18nService.language" [attr.dir]="i18nService.direction">
  @if (branchName) {
    <div
      class="fixed top-1 left-1 right-1 z-[99999] text-neutral-600 text-sm font-mono px-2 -mt-1 overflow-hidden text-ellipsis whitespace-nowrap">
      {{ branchName }}
    </div>
  }
  <app-layout class="min-h-screen flex flex-col"></app-layout>

  <app-loading />
</div>
